import React from 'react';

const LetterSpacing = () => {
  return (
    <div className="letter-spacing">
      <div className="letter-spacing-container">
        <h4>文字飞入效果</h4>
        <div className="letter-spacing-container-box">
          我是飞进来的嗷
        </div>
      </div>
      <div className="letter-spacing-desc"></div>
    </div>
  );
};

export default LetterSpacing;
